import { useCallback, useRef, useState } from "react";

/**
 * useBidTimer — manages the visual countdown timer for bid windows.
 *
 * Returns { timerRemainingMs, timerTotalMs, startVisualTimer, clearVisualTimer }.
 */
export default function useBidTimer() {
  const [timerRemainingMs, setTimerRemainingMs] = useState(0);
  const [timerTotalMs, setTimerTotalMs] = useState(0);

  const timerIntervalRef = useRef(null);
  const timerDeadlineRef = useRef(null);

  const clearVisualTimer = useCallback(() => {
    if (timerIntervalRef.current) {
      clearInterval(timerIntervalRef.current);
      timerIntervalRef.current = null;
    }
    timerDeadlineRef.current = null;
    setTimerRemainingMs(0);
  }, []);

  const startVisualTimer = useCallback(
    durationMs => {
      clearVisualTimer();
      setTimerTotalMs(durationMs);
      setTimerRemainingMs(durationMs);
      timerDeadlineRef.current = Date.now() + durationMs;

      timerIntervalRef.current = setInterval(() => {
        if (!timerDeadlineRef.current) {
          return;
        }

        const remaining = Math.max(0, timerDeadlineRef.current - Date.now());
        setTimerRemainingMs(remaining);

        if (remaining <= 0) {
          clearVisualTimer();
        }
      }, 100);
    },
    [clearVisualTimer]
  );

  return { timerRemainingMs, timerTotalMs, startVisualTimer, clearVisualTimer };
}
